import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const ChannelListDescriptionContainer = styled.div<{ focused?: boolean }>`
  display: flex;
  flex-direction: column;
  left: ${523 * Screen.widthRatio}px;
  top: ${120 * Screen.widthRatio}px;
  width: 100%;
`;

export default withAnimation(ChannelListDescriptionContainer);
